import React from 'react';
import { useApplication } from '../../context/ApplicationContext';

const ProgressIndicator = () => {
  const { currentStep, completedSteps } = useApplication();

  const steps = [
    { id: 1, name: 'Demographics & Academics', description: 'Background & Test Scores' },
    { id: 2, name: 'Work Experience', description: 'Resume & Career History' },
    { id: 3, name: 'Essays & Goals', description: 'Application Essays' }
  ];

  const getStepStatus = (stepId) => {
    if (completedSteps.includes(stepId)) {
      return 'completed';
    } else if (stepId === currentStep) {
      return 'current';
    } else {
      return 'upcoming';
    }
  };

  const getStepClasses = (status) => {
    const baseClasses = "step-indicator";
    switch (status) {
      case 'completed':
        return `${baseClasses} step-completed`;
      case 'current':
        return `${baseClasses} step-current`;
      case 'upcoming':
        return `${baseClasses} step-upcoming`;
      default:
        return `${baseClasses} step-upcoming`;
    }
  };

  // Calculate progress percentage for 3 steps
  const calculateProgress = () => {
    // If current step is 3 (final step), show 100%
    if (currentStep >= 3) return 100;
    
    // For steps 1-2, calculate based on completion  
    const progressPerStep = 100 / (steps.length - 1); // Each step is worth 50%
    return Math.round((currentStep - 1) * progressPerStep);
  };

  return (
    <div className="card p-6 mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.id} className="flex-1 flex items-center">
            <div className="flex flex-col items-center">
              <div className={`${getStepClasses(getStepStatus(step.id))} mb-2`}>
                {getStepStatus(step.id) === 'completed' ? '✓' : step.id}
              </div>
              <div className="text-center">
                <h3 className={`text-sm font-medium ${
                  getStepStatus(step.id) === 'current' ? 'text-primary-600' : 'text-gray-700'
                }`}>
                  {step.name}
                </h3>
                <p className="text-xs text-gray-500 mt-1">{step.description}</p>
              </div>
            </div>
            
            {/* Connector line */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-0.5 bg-gray-200 mx-4 mt-[-2rem]">
                <div 
                  className={`h-full transition-all duration-300 ${
                    completedSteps.includes(step.id) ? 'bg-success-500' : 'bg-gray-200'
                  }`}
                  style={{ width: completedSteps.includes(step.id) ? '100%' : '0%' }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      
      {/* Progress bar */}
      <div className="mt-6">
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${calculateProgress()}%` }}
          />
        </div>
        <div className="flex justify-between text-xs text-gray-500 mt-2">
          <span>Step {currentStep} of {steps.length}</span>
          <span>{calculateProgress()}% Complete</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator; 